<template>
  <el-dialog
    title="添加商店"
    width="70%"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :append-to-body="true"
  >
    <div class="form-tip mb20 flex flex-start">
      <el-input
        v-model="searchKeyword"
        placeholder="请输入商店名称搜索"
        clearable
        size="small"
        style="width: 200px;margin-right: 20px;"
      >
      </el-input>
      <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
    </div>
    <div class="mb10" v-if="!isSingleSelect">
      <el-button
        :type="isAllSelected ? 'danger' : 'primary'"
        size="small"
        plain
        @click="handleSelectAllClick"
      >
        {{ isAllSelected ? '取消全选' : '全选商店' }}
      </el-button>
    </div>
    <div class="mb20">
      <el-table
        stripe
        border
        height="400"
        ref="storeTable"
        @row-click="handleRowClick"
        @selection-change="getStoreChecked"
        :data="filteredData"
        style="width: 100%"
        id="table"
        size="small"
        :key="isSingleSelect ? 'single' : 'multi'"
      >
        <el-table-column v-if="!isSingleSelect" key="multi-select" type="selection" width="55"></el-table-column>
        <el-table-column v-else key="single-select" width="55" align="center">
          <template slot-scope="scope">
            <el-radio
              v-model="singleSelectedCode"
              :label="scope.row.shopCode"
            ></el-radio>
          </template>
        </el-table-column>
        <el-table-column type="index" :index="indexMethod" label="序号"></el-table-column>
        <el-table-column
          v-if="showStoreType"
          header-align="center"
          align="center"
          prop="joinType"
          label="商店类型"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.joinType === 'join' ? '加盟店' : '直营店' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="商店名称"
          prop="shopName"
        >
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <div class="hm-pagination mt20">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <div class="flex flex-center mt20">
      <el-button size="small" type="primary" @click="confirmAddStore"
        >确 定
      </el-button>
      <el-button size="small" @click="handleCancel"
        >取 消
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'StoreDialog',
  props: {
    // 控制对话框显示隐藏
    visible: {
      type: Boolean,
      default: false
    },
    // 所有商店数据
    allStores: {
      type: Array,
      default: () => []
    },
    // 已选中的商店列表
    selectedStores: {
      type: Array,
      default: () => []
    },
    // 商店编码（用于判断是否显示商店类型）
    storeCode: {
      type: String,
      default: ''
    },
    // 商店类型筛选（从父组件传入）
    storeTypeFilter: {
      type: String,
      default: 'all'
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 当前页面选中的商店
      currentSelectedStores: [],
      // 当前分页的数据
      filteredData: [],
      // 搜索关键词
      searchKeyword: '',

      // 过滤后的商店列表
      filteredStores: [],
      // 是否正在重置选中状态（防止 selection-change 事件覆盖）
      isResettingSelection: false,
      // 单选时选中的商店编码
      singleSelectedCode: ''
    };
  },
  computed: {
    // 通过 v-model 双向绑定对话框显示状态
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    // 是否显示商店类型筛选和列
    showStoreType() {
      return this.storeCode === '53010017032439' || this.storeCode === '42010216070190';
    },
    // 是否全选（基于所有过滤后的商店）
    // 注意：只检查 currentSelectedStores，因为这才是弹窗中实际选中的
    isAllSelected() {
      if (this.filteredStores.length === 0) {
        return false;
      }
      const selectedCodes = new Set(this.currentSelectedStores.map(s => s.shopCode));
      return this.filteredStores.every(store => selectedCodes.has(store.shopCode));
    },
    // 是否单选模式（加盟店只能选一条）
    isSingleSelect() {
      return this.storeTypeFilter === 'join';
    }
  },
  watch: {
    // 监听当前页和每页条数变化，更新分页数据
    currentPage() {
      this.resetCurrentSelection();
    },
    pageSize() {
      this.resetCurrentSelection();
    },
    // 监听对话框打开
    visible(val) {
      if (val) {
        this.currentPage = 1;
        // 打开弹框时清空搜索关键词并获取数据
        this.searchKeyword = '';
        // 初始化当前选中列表为已选商店的副本
        this.currentSelectedStores = [...this.selectedStores];
        // 单选模式下，初始化选中的编码
        if (this.isSingleSelect && this.selectedStores.length > 0) {
          this.singleSelectedCode = this.selectedStores[0].shopCode;
        } else {
          this.singleSelectedCode = '';
        }
        this.fetchStoreList();
        this.$nextTick(() => {
          this.resetCurrentSelection();
        });
      }
    },

  },
  methods: {
    // 获取商店列表数据（前端分页）
    fetchStoreList() {
      // 保存当前选中状态（防止表格数据变化时触发 selection-change 覆盖）
      const savedSelection = [...this.currentSelectedStores];
      // 标记正在重置选中状态
      this.isResettingSelection = true;

      // 先过滤（商店名称 + 商店类型）
      this.filteredStores = this.allStores.filter(store => {
        // 商店名称过滤
        let nameMatch = true;
        if (this.searchKeyword) {
          nameMatch = store.shopName && store.shopName.includes(this.searchKeyword);
        }

        // 商店类型过滤（根据父组件传入的storeTypeFilter）
        let typeMatch = true;
        if (this.showStoreType && this.storeTypeFilter && this.storeTypeFilter !== 'all') {
          if (this.storeTypeFilter === 'join') {
            typeMatch = store.joinType === 'join';
          } else if (this.storeTypeFilter === 'self') {
            typeMatch = store.joinType !== 'join';
          }
        }

        return nameMatch && typeMatch;
      });

      // 更新总数
      this.total = this.filteredStores.length;

      // 分页
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.filteredData = this.filteredStores.slice(start, end);

      // 重置当前页选中项
      this.$nextTick(() => {
        // 恢复保存的选中状态
        this.currentSelectedStores = savedSelection;
        this.resetCurrentSelection();
      });
    },
    // 重置当前页选中状态
    resetCurrentSelection() {
      if (this.$refs.storeTable) {
        this.$refs.storeTable.clearSelection();

        // 根据当前选中列表恢复选中状态
        this.$nextTick(() => {
          this.filteredData.forEach(row => {
            const isSelected = this.currentSelectedStores.some(selected => selected.shopCode === row.shopCode);
            if (isSelected) {
              this.$refs.storeTable.toggleRowSelection(row, true);
            }
          });
          // 重置完成后清除标志位
          this.isResettingSelection = false;
        });
      } else {
        this.isResettingSelection = false;
      }
    },
    // 处理表格行点击
    handleRowClick(row) {
      if (this.isSingleSelect) {
        // 单选模式
        this.singleSelectedCode = row.shopCode;
        this.currentSelectedStores = [row];
      } else {
        // 多选模式
        this.$refs.storeTable.toggleRowSelection(row);
      }
    },
    // 处理单选
    handleSingleSelect(row) {
      this.currentSelectedStores = [row];
    },
    // 处理选择变化
    getStoreChecked(selection) {
      // 如果正在重置选中状态，则不处理（防止 fetchStoreList 触发的事件覆盖选中状态）
      if (this.isResettingSelection) {
        return;
      }
      // 获取当前页所有数据的商店编码
      const currentPageCodes = new Set(this.filteredData.map(s => s.shopCode));
      // 从当前选中列表中移除当前页的数据
      const otherPagesSelected = this.currentSelectedStores.filter(s => !currentPageCodes.has(s.shopCode));
      // 合并当前页的选中数据
      this.currentSelectedStores = [...otherPagesSelected, ...selection];
    },
    // 计算序号
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    // 处理每页条数变化
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchStoreList();
    },
    // 处理当前页变化
    handleCurrentChange(page) {
      this.currentPage = page;
      this.fetchStoreList();
    },
    // 确认添加商店
    confirmAddStore() {
      // 使用当前选中列表作为最终结果（已包含所有需要的商店）
      this.$emit('confirm', this.currentSelectedStores);
    },
    // 取消操作
    handleCancel() {
      this.dialogVisible = false;
    },
    // 处理搜索
    handleSearch() {
      this.currentPage = 1;
      this.fetchStoreList();
    },
    // 处理全选/取消全选按钮点击
    handleSelectAllClick() {
      const isAllSelected = this.isAllSelected;
      const filteredCodes = new Set(this.filteredStores.map(s => s.shopCode));

      if (!isAllSelected) {
        // 全选：将所有过滤后的商店添加到当前选中列表
        const existingCodes = new Set([
          ...this.selectedStores.map(s => s.shopCode),
          ...this.currentSelectedStores.map(s => s.shopCode)
        ]);
        const storesToAdd = this.filteredStores.filter(store => !existingCodes.has(store.shopCode));
        // 更新当前选中项
        this.currentSelectedStores = [...this.currentSelectedStores, ...storesToAdd];
        // 更新表格选中状态
        this.$nextTick(() => {
          this.filteredData.forEach(row => {
            this.$refs.storeTable.toggleRowSelection(row, true);
          });
        });
      } else {
        // 取消全选：从当前选中列表中移除所有过滤后的商店
        this.currentSelectedStores = this.currentSelectedStores.filter(store => !filteredCodes.has(store.shopCode));
        // 清空表格选中状态
        this.$refs.storeTable.clearSelection();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-tip {
  margin-bottom: 20px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt20 {
  margin-top: 20px;
}

.flex {
  display: flex;
}

.flex-center {
  align-items: center;
  justify-content: center;
}

.flex-start {
  align-items: center;
}

.hm-pagination {
  font-family: PingFang SC;
}
// /deep/ .el-icon-circle-close:before {
//   content: "\E78D";
// }
// /deep/ .el-icon-circle-close:after {
//     content: "\E78D";
// }
/deep/ .el-input__validateIcon {
    display: none;
}

// 隐藏单选按钮的 label 文字，只显示圆圈
/deep/ .el-radio__label {
  display: none;
}
</style>
